/* globals isLoginPage, isAngularLogin  */
import 'regenerator-runtime';
import misc from './components/misc';
import form from './components/form';
import csrf from './components/csrf';
import modal from './components/modal';
import cart from './components/cart';
import adyenCreditCard from './components/adyenCreditCard';
import bancontactAdyenCreditCard from './components/bancontactAdyenCreditCard';
import bancontact from './components/bancontact';
import mobileApp from './components/mobileapp';
import savingsplan from './components/savingsplan';
import loyaltyManagement from './components/loyaltyManagement';
import subscription from './components/subscription';
import coupon from './components/coupon';
import { initBanners } from './components/contentful';
import { initSnackbar } from './components/snackbar';
import address from './pages/address';
import payment from './pages/payment';
import preview from './pages/preview';
import finish from './pages/finish';
import shippingAddress from './pages/shippingAddress';
import invoiceAddress from './pages/invoiceAddress';
import login from './pages/login';
import { showPageLoader } from './utils';
import { setupSentry } from './services/sentryService';
import { initSSO } from './utils/sso';
import { initOptimizely } from './services/optimizelyService';
import adobeService from './services/adobeService';
import cookies from './utils/cookies';

const uA = window.navigator.userAgent;
const vendor = window.navigator.vendor;

if (
  /Safari/.test(uA) &&
  /Apple Computer/.test(vendor) &&
  !/Mobi|Android/i.test(uA)
)
  document.body.classList += ' isSafari';

window.zooplus = {};
window.zooGlobObj = $({});
window.globObj = window.zooGlobObj;

setupSentry();

const loginPages =
  (typeof isLoginPage !== 'undefined' && isLoginPage) ||
  (typeof isAngularLogin !== 'undefined' && isAngularLogin);
const isFinishPage = window.location.pathname.includes('finish');
const isPreviewPage = window.location.href.includes('preview');
const isLogoutPage = window.location.href.includes('logout');
const isEditInvoiceAddressPage = window.location.href.includes('editaddress');

if (isPreviewPage) {
  loyaltyManagement.init();
} else if (isFinishPage) {
  finish.getKeycloakTokenForAuthorizer();
}

// On ready
$(document).ready(function () {
  cookies.init();
  csrf.init();
  adobeService.init();
  initOptimizely();
  address.init();
  misc.init();
  form.init();
  modal.init();
  cart.init();
  initSnackbar();
  mobileApp.init();
  shippingAddress.init();
  adyenCreditCard.init();
  bancontactAdyenCreditCard.init();
  bancontact.init();
  payment.init();
  savingsplan.init();

  if (isPreviewPage) {
    preview.init();
    subscription.init();
    coupon.init();
  }

  if (isFinishPage) {
    finish.init();
    initBanners();
  }

  if (loginPages) login.init();

  if (isLogoutPage) {
    showPageLoader();
    initSSO();
  }

  if (
    typeof isLoginPage !== 'undefined' &&
    isLoginPage &&
    cookies.get('MOBILE_APP')
  )
    initSSO();

  if (isEditInvoiceAddressPage) {
    invoiceAddress.init();
  }
});
